import { HTMLProps, ReactNode, useState } from "react";
import { Button } from "react-bootstrap";
// styles
import styles from "./styles.module.scss";
// components
import { ReactComponent as OutlinePlus16 } from "assets/svg/outline-plus-16.svg";
import DropZone from "./components/drop-zone";
// utils
import getClasses from "utils/getClasses";
import messages from "messages";

type Props = {
  storageDrive: StorageDrive;
  TextInitial?: ReactNode;
} & Pick<HTMLProps<HTMLDivElement>, "className" | "onDrop"> &
  Pick<HTMLProps<HTMLInputElement>, "onChange" | "accept">;

/**
 * renders the UI for uploading files
 */
const UploadZone = ({
  onDrop,
  onChange,
  storageDrive,
  className,
  TextInitial,
  accept,
}: Props) => {
  const [draggingOver, setDraggingOver] = useState(false);

  return (
    <div
      className={getClasses(
        styles["upload-zone"],
        draggingOver && styles["upload-zone--mouse-over"],
        className,
      )}
      onDragEnter={(e) => {
        e.preventDefault();
        e.stopPropagation();
        setDraggingOver(true);
      }}
    >
      {draggingOver ? (
        <DropZone
          storageDrive={storageDrive}
          className={styles["upload-zone__drop-zone"]}
          onDrop={(e) => {
            e.preventDefault();
            e.stopPropagation();
            setDraggingOver(false);
            return onDrop && onDrop(e);
          }}
          // !! need this onDragOver to make onDrop work
          onDragOver={(e) => {
            e.preventDefault();
            e.stopPropagation();
          }}
          onDragLeave={(e) => {
            e.preventDefault();
            e.stopPropagation();
            setDraggingOver(false);
          }}
        />
      ) : (
        <div className="text-center">
          {TextInitial || (
            <>
              <p className="mb-0 rg-16 gray01">{messages.dropYourFileHere}</p>
              <p className="rg-14 gray02">{messages.maxFileSize}</p>
              <div className="mb-3 rg-24 gray01">{messages.or}</div>
            </>
          )}
          <Button
            variant="outline-primary"
            className={styles["upload-zone__action"]}
            size="sm"
          >
            <label className="mb-0">
              <input
                type="file"
                multiple
                hidden
                onChange={onChange}
                accept={accept}
              />
              <OutlinePlus16 className="mr-2" />
              {messages.uploadFromComputer}
            </label>
          </Button>
        </div>
      )}
    </div>
  );
};

export default UploadZone;
